import AppModule from '@app/lib/AppModule';
import appManager from '@app/appManager';

class VoicemailsModule extends AppModule {
  override events = ['voicemail.update'];
}

export default new VoicemailsModule(
  appManager.events,
  appManager.logger('Voicemails'),
);
